<template>
  <div class="campaigns-index">
    <div v-if="$can('list_personal_campaigns')">

      <CampaignInsights :is_admin="0" />

      <div class="my-10"></div>
      <CampaignsAdvertisersTable />
    </div>
  </div>
</template>

<script>
import CampaignInsights from '@/views/campaigns/index/components/CampaignInsights.vue'

import CampaignsAdvertisersTable from '@/views/campaigns/index/components/CampaignsAdvertisersTable.vue'

export default {
  components: {
    CampaignInsights,
    CampaignsAdvertisersTable
  }
}
</script>

<style lang="scss">
.campaigns-index {
  .vs-switch:disabled {
    background-color: #e2e2e2 !important;
  }
}
</style>
